import { PropsWithChildren } from "react";
import { AccountBreadcrumbs } from "../components/AccountBreadcrumbs";
import { Grid } from "@mui/material";

type AccountPageSectionProps = {
  testId: string;
  label: string;
};

export function AccountPageSection(
  props: PropsWithChildren<AccountPageSectionProps>
) {
  return (
    <Grid container item data-testid={props.testId} xs={12} spacing={3}>
      <Grid item xs={12}>
        <AccountBreadcrumbs label={props.label} />
      </Grid>
      <Grid container item xs={12}>
        {props.children}
      </Grid>
    </Grid>
  );
}
